<script setup lang="ts">
import dayjs from 'dayjs'
import { getShareRepurchaseList } from '@/api/modules/home'
import charts from '../components/charts.vue'

definePage({
  name: 'share-repurchase',
  meta: {
    title: '股份回购',
  },
})
const date = dayjs().format('YYYY/MM/DD')
const list = ref([]) as any
const loading = ref(false)
const finished = ref(false)

async function onLoad() {
  try {
    const { status, data } = await getShareRepurchaseList({
      page: 1,
    })
    if (status === 1) {
      list.value = data.list
      finished.value = data.finished
    }
  }
  catch (error) {
    console.error(error)
  }
  finally {
    loading.value = false
  }
}
</script>

<template>
  <FmPageLayout navbar back class="page">
    <template #navbar-end>
      <FmIcon name="ri:share-forward-box-line" class="m-l-16px text-22px color-[#fff]" />
    </template>
    <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="bg-[#fff]">
        <van-search placeholder="请输入关键字/股票代码" />
        <div class="p-6px text-15px font-500">
          市场回购全景
        </div>
        <div class="m-b-8px m-l-8px m-r-8px flex items-center justify-between">
          <div class="flex items-center color-[#999]">
            <span class="text-11px">单位：亿港元</span>
          </div>
        </div>
        <div class="h-180px">
          <charts />
        </div>
      </div>
      <div class="m-t-10px bg-[#fff]">
        <div class="p-6px text-15px font-500">
          近期回购
        </div>
        <div class="m-b-8px m-l-8px m-r-8px flex items-center justify-between">
          <div class="flex items-center color-[#999]">
            <span class="text-11px">截止：{{ date }}</span>
          </div>
          <div class="flex items-center color-[#333]">
            <span class="text-11px">{{ date }}</span>
            <FmIcon name="material-symbols:expand-more-rounded" class="text-lg color-[#333]" />
          </div>
        </div>
        <vxe-table
          header-row-class-name="table-header"
          :data="list"
        >
          <vxe-column field="name" title="名称">
            <template #default="{ row }">
              <div class="text-15px font-500">
                {{ row.name }}
              </div>
              <div class="text-13px">
                {{ row.code }}
              </div>
            </template>
          </vxe-column>
          <vxe-column field="totalProportion" title="占总股本比例" sortable />
          <vxe-column field="dayProportion" title="占当日成交比例" sortable align="right" />
        </vxe-table>
      </div>
    </van-list>
  </FmPageLayout>
</template>

<style lang="scss" scoped>
.page {
  .dropdown {
    :deep(.van-dropdown-menu__bar) {
      height: 34px;
      background-color: #f1f2f7;
      border-radius: 5px;
      box-shadow: none;
    }

    :deep(.van-dropdown-menu__title::after) {
      border-color: transparent transparent #999 #999;
    }
  }
}
</style>
